import { render, staticRenderFns } from "./BloggerHome.vue?vue&type=template&id=2aa4f27c&scoped=true"
import script from "./BloggerHome.vue?vue&type=script&lang=js"
export * from "./BloggerHome.vue?vue&type=script&lang=js"
import style0 from "./BloggerHome.vue?vue&type=style&index=0&id=2aa4f27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa4f27c",
  null
  
)

export default component.exports